export default {
  common: () => import("/home/jetmix/histrf.ru/histrf-client/layouts/Common.vue"),
  custom: () => import("/home/jetmix/histrf.ru/histrf-client/layouts/custom.vue"),
  default: () => import("/home/jetmix/histrf.ru/histrf-client/layouts/default.vue"),
  marginless: () => import("/home/jetmix/histrf.ru/histrf-client/layouts/marginless.vue")
}